import React, { Component, Fragment } from "react";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { PropTypes } from "prop-types";

import { logOutAction } from "../../actions/UserActions";

import * as JSZip from "jszip";

import { SongRow } from "../../components";

import {
  FavoriteH1,
  CitTable,
  PrimaryButton,
} from "../../components/HelperComponents/StyledComponents";

import { SongTableHeader } from "../../components/HelperComponents/HelperComponents";

import { fetchResultsIfNeeded } from "../../actions/ResultsActions";

// import { VisibilityFilters } from '../../actions/DataDefaultActions';
import { playlistClear, playlistReplace } from "../../actions/PlaylistActions";

import { getSonglistHash } from "../../helpers";

export class ResultsComponent extends Component {
  static propTypes = {
    newAlbums: PropTypes.object,
    results: PropTypes.object,
    location: PropTypes.object,
    searchParams: PropTypes.object,
    match: PropTypes.object,
  };

  state = {
    currentPage: 1,
  };

  componentDidMount() {
    let newPage = this.state.currentPage + 1;
    this.loadSongsBasedOnQuery(this.props.match, this.state.currentPage, true);

    this.setState({ currentPage: newPage });
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.match.params.searchQuery !== prevProps.match.params.searchQuery
    ) {
      this.setState({ currentPage: 1 });

      this.loadSongsBasedOnQuery(this.props.match, 1, true);
    }

    const songs = this.props.results.items || [];
    const songsPrev = prevProps.results.items || [];

    if (getSonglistHash(songs) !== getSonglistHash(songsPrev)) {
      this.props.playlistReplace(songs);
    }
  }

  loadSongsBasedOnQuery(match, page, eraseLastState) {
    let newPage = page + 1;

    this.props
      .fetchResultsIfNeeded(match.params.searchQuery, "", page, eraseLastState)
      .catch((e) => {
        //this.props.logOutAction(this.props.history);
      });

    if (eraseLastState) {
      this.props.playlistClear();
    }

    this.setState({ currentPage: newPage });
  }

  loadMoreResults = () => {
    if (this.state.currentPage <= this.props.results.totalPages) {
      this.loadSongsBasedOnQuery(
        this.props.match,
        this.state.currentPage,
        false,
      );
    }
  };

  render() {
    const { match } = this.props;
    const songs = this.props.results.items || [];
    const currentSongId = this.props.currentSong && this.props.currentSong.id;
    document.body.classList.remove("is_album");

    const allSongs = songs.map((cov, i) => {
      const song = cov ? cov : {};
      const isActive = song.id && song.id === currentSongId;
      const isLoading = isActive && this.props.isLoading;
      const isPlaying = isActive && this.props.isPlaying;

      return (
        <SongRow
          key={"songRow_result_" + i}
          song={song}
          numeration={i}
          isActive={isActive}
          isLoading={isLoading}
          isPlaying={isPlaying}
          shouldShowAlbumCover={true}
          shouldLinkAlbumTitle={true}
        />
      );
    });

    const shouldShowLoader =
      this.props.results.isFetching && this.props.results.didEraseLastState;
    // var is_download_available = false;
    const searchQuery = match.params.searchQuery;
    const hasSearch = typeof searchQuery !== 'undefined' && searchQuery != null && searchQuery !== '';
    const hasFilters = this.props.filters.selected.length > 0;

    // NEW: show the whole results area ONLY if there is a search OR at least one filter
    const shouldShowSection = hasSearch || hasFilters;

    // Download button only appears when we actually have songs
    const showDownload = songs.length > 0;

    return (
      <Fragment>
        {shouldShowSection && (
          <section className="column is-11 loading">
            {shouldShowLoader && <div>Loading...</div>}

            <div className="field is-grouped download_all">
              <a id="download_all_hidden">dall</a>
              {showDownload && (
                <a
                  id="download_all"
                  className="button fbSwuH"
                  onClick={() => {
                    // ... your existing download-all code (unchanged) ...
                    const promise = 'hello';
                    document.getElementsByTagName("body")[0].classList.toggle('downloading');

                    console.log(promise);
                    console.log(songs);

                    var urls = [];
                    const allSongs = songs.map((cov, i) => {
                      const song_title = cov.product_file.post_title;
                      const song_download = cov.product_file.url;
                      urls.push(song_download);
                    });

                    var zip = new JSZip();
                    var a = document.getElementById('download_all_hidden');

                    function request(url) {
                      return new Promise(function (resolve) {
                        var httpRequest = new XMLHttpRequest();
                        httpRequest.open("GET", url);
                        httpRequest.responseType = 'blob';

                        httpRequest.onload = function () {
                          var filename = url.split('/').pop();
                          zip.file(filename, this.response, { binary: true });
                          resolve();
                        };
                        httpRequest.send();
                      });
                    }

                    Promise.all(urls.map(function (url) {
                      return request(url);
                    }))
                      .then(function () {
                        console.log(zip);
                        zip.generateAsync({
                          type: "blob",
                          compression: "DEFLATE"
                        })
                          .then(function (content) {
                            document.getElementsByTagName("body")[0].classList.toggle('downloading');

                            a.download = "search_results";
                            a.href = URL.createObjectURL(content);
                            a.innerHTML = a.download;
                            document.getElementById('download_all_hidden').click();
                          });
                      });
                  }}
                >
                  Download all results
                </a>
              )}
            </div>

            {!shouldShowLoader && (
              <div>
                <section className="field">
                  <FavoriteH1 className="has-text-weight-bold">
                    {songs.length === 0
                      ? `Sorry, no results.`
                      : (() => {
                          const parts = [];

                          // Search query part
                          if (hasSearch) {
                            parts.push(`${searchQuery}`);
                          }

                          // Active filters part
                          if (hasFilters) {
                            const filterLabels = this.props.filters.selected
                              .map((fil) => {
                                const f = fil.filter || {};
                                // Try the most common fields that your backend returns
                                return (
                                  f.post_title ||
                                  f.title ||
                                  f.name ||
                                  f.slug ||
                                  `${fil.type} #${f.id || ''}`
                                ).trim();
                              })
                              .filter(Boolean)
                              .join(', ');

                            if (filterLabels) parts.push(filterLabels);
                          }

                          return `Results for "${parts.join(' + ')}"`;
                        })()}
                  </FavoriteH1>
                </section>

                <CitTable className="table is-fullwidth has-text-white" theme={{ tableRowBackgroundColor: '#191919' }}>
                  <SongTableHeader />
                  <tbody className="is-hoverable">
                    {allSongs}
                  </tbody>
                </CitTable>

                {(this.state.currentPage <= this.props.results.totalPages && !hasFilters) &&
                  <section className="has-text-centered">
                    {this.props.results.isFetching && <span style={{ fontSize: '1.5rem' }}>...</span>}
                    {!this.props.results.isFetching && (
                      <PrimaryButton style={{ padding: '0.5em' }} onClick={this.loadMoreResults}>
                        <span>Load More</span>
                      </PrimaryButton>
                    )}
                  </section>
                }
              </div>
            )}
          </section>
        )}
      </Fragment>
    );
  }
}

const getVisibleResults = (results, filter) => {
  if (!filter) return results;

  let filteredResults = results.filter((res) => {
    let isValid = filter.every((fil, i) => {
      let filterSet = res[`product_${fil.type}`];
      // todo temp fix. We expect an array, but it's coming back an as object for now.
      if (filterSet.id) {
        filterSet = [filterSet];
      }
      if (
        filterSet &&
        filterSet.length &&
        filterSet.find((product, i) => {
          return product.id == fil.filter.id;
        })
      ) {
        return true;
      } else {
        return false;
      }
    });

    return isValid;
  });
  return filteredResults;
};

function mapStateToProps(state) {
  const { results, filters, playerSong } = state;

  const items = [...getVisibleResults(results.items, filters.selected)];

  let filtered = {
    ...results,
    items,
  };

  const { isPlaying, isLoading, currentSong } = playerSong || {
    currentSong: null,
    isPlaying: false,
    isLoading: false,
  };

  return {
    results: filtered,
    currentSong,
    isPlaying,
    isLoading,
    filters,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchResultsIfNeeded,
      playlistClear,
      playlistReplace,
      logOutAction,
    },
    dispatch,
  );
}

export const Results = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ResultsComponent),
);



// WEBPACK FOOTER //
// ./src/routes/Results/Results.js